import {Box, Skeleton} from '@mui/material';

import {departmentHealthSectionCardSx} from './departmentHealthSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export interface Props {
  embedded?: boolean;
}

export const DepartmentHealthSkillCoverageMapSkeleton = ({embedded = false}: Props) => {
  const cardSx = embedded ? {...departmentHealthSectionCardSx, mb: 0} : departmentHealthSectionCardSx;

  return (
    <EmpionPaper sx={cardSx}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5}}>
        <Skeleton variant='circular' width={15} height={15} />
        <Skeleton variant='text' width={150} height={18} />
      </Box>
      <Skeleton variant='text' width='90%' height={14} sx={{mb: 2}} />
      <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', md: 'repeat(3, 1fr)'}, gap: 2.5}}>
        {Array.from({length: 3}).map((_, columnIndex) => (
          <Box key={columnIndex}>
            <Skeleton variant='text' width={120} height={14} sx={{mb: 1}} />
            {Array.from({length: 4}).map((__, rowIndex) => (
              <Skeleton key={rowIndex} variant='text' width='100%' height={20} sx={{mb: 0.5}} />
            ))}
          </Box>
        ))}
      </Box>
    </EmpionPaper>
  );
};
